module.exports = __webpack_public_path__ + "static/media/INACTIVE.cda53f2e.svg";